import { useMutation } from '@tanstack/react-query';
import { gravarCamposApi } from '../api/GravarCamposApi';
import type { GravarCamposPayload } from '../types';

export function useGravarCampos() {
  return useMutation<void, Error, GravarCamposPayload>({
    mutationFn: gravarCamposApi,
  });
}
